import { type RestaurantTagType } from '@discover-data/stores/restaurant/gql/fragments/restaurantTag';
import { type PeopleOption } from '@discover-data/stores/hooks/people/options';
import { cn } from '@discover-lib/utils';
import NoResultsIcon from '@discover-ui/icons/no-results-light.svg';
import EmptyMessageSubtext from './subtext';
import EmptyMessageResetButton from './resetButton';
import EmptyMessageTitle from './title';

export type RestaurantListEmptyMessageProps = {
  tags: RestaurantTagType[];
  className?: string;
  peopleOptions?: PeopleOption[] | null;
  minDiners?: PeopleOption | null;
  maxDiners?: PeopleOption | null;
};

export default function RestaurantListEmptyMessage({
  tags,
  className,
  peopleOptions,
  minDiners,
  maxDiners,
}: RestaurantListEmptyMessageProps) {
  return (
    <div
      className={cn(
        'prose flex max-w-none flex-col items-center gap-4 p-4 text-center lg:gap-8 lg:p-8',
        className
      )}>
      <NoResultsIcon className="h-auto w-[300px] max-w-full" />
      <EmptyMessageTitle />
      <EmptyMessageSubtext
        peopleOptions={peopleOptions}
        minDiners={minDiners}
        maxDiners={maxDiners}
      />
      <EmptyMessageResetButton tags={tags} />
    </div>
  );
}
